<template>
    <div style="background: #0d6fb8">
        <headerNav title="奖品" />
        <div>
            <img style="width: 100%;" src="../../assets/images/cj02.jpg" />
        </div>
        <!-- <img style="width: 100%" src="../../assets/images/fh001.jpg" /> -->
        <div class="drawcards">
            <van-divider :style="{ color: '#fff', borderColor: '#ffffff', padding: '0 16px' }">
                <h2>我的奖品</h2>
            </van-divider>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="navitem.loaded"
                :finished="navitem.loadingType == 'nomore' ? true : false"
                @load="loadData"
            >
                <div class="drawcard" v-for="(item,index) in navitem.list" @click="opengift(item)" :key="index">
                    <div class="draw-content">
                        <div class="drawcard-pic">
                            <img :src="$baseurl+item.productPic" />
                        </div>
                        <div class="drawcard-wz">
                            <div>{{item.productName}}</div>
                            <div>{{item.drawTime}} 
                                <span style="float:right;font-size:12px">
                                    <span v-if="item.drawLotteryEnum==0&&!item.isUsed">点击领取</span>
                                    <span v-if="item.drawLotteryEnum==2">查看联系方式</span>
                                </span>
                             </div>
                        </div>
                        <div class="drawcard-mm">
                            <span  v-if="item.drawLotteryEnum==0&&!item.isUsed">未领取</span>
                            <span  v-if="item.drawLotteryEnum==0&&item.isUsed&&item.drawTid">已领取</span>
                            <span  v-if="item.drawLotteryEnum==0&&item.isUsed&&!item.drawTid">已超期</span>
                            <span  v-if="item.drawLotteryEnum==2">请联系上级代理索取</span>
                            <span  v-if="item.payment"> | 需支付{{item.payment}}元</span>
                        </div>
                    </div>
                </div>
             </van-list>
            </van-pull-refresh>
            <div v-if="navitem.list.length == 0" style="text-align: center; font-size: 14px">
                您目前没有奖品哦,赶紧参与抽奖活动吧
            </div>
        </div>

       <van-dialog v-model="nshow" title="领取" @confirm="gobuy()"  show-cancel-button showConfirmButton confirmButtonText="领取">
            <div style="color:#a8a8a8;padding:10px;">
                温馨提示：礼品的收货地址为您的默认地址，请确认地址是否准确。
                <span style="color:red" v-if="defaultaddress">
                    当前礼品收件信息为：{{ defaultaddress.receiverName }}，{{
            defaultaddress.receiverMobile
          }}，{{
            defaultaddress.receiverState +
            defaultaddress.receiverCity +
            defaultaddress.receiverDistrict +
            defaultaddress.receiverAddress
          }}。（如不正确，请到收货地址管理变更默认地址后再领取）
                </span>
                <div v-if="curitem&&curitem.isMoreSpec">
                    <van-field
                        v-model="checkvalue"
                        readonly
                        clickable
                        name="picker"
                        label="规格选择"
                        placeholder="点击选择规格"
                        @click="showPicker = true"
                        />
                </div>
            </div>
            
        </van-dialog>

        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                title="选择规格"
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
        </van-popup>

        <van-dialog v-model="fshow" title="上级代理"   showConfirmButton confirmButtonText="确定">
            <div style="color:#a8a8a8;padding:10px;line-height:22px;text-align:center" v-if="parentinfo">
               <div>
                   {{parentinfo.dealerName}}
               </div>
               <div>
                   {{parentinfo.phoneNum}}
               </div>
               <div v-if="parentinfo.qrCodeUrl">
                   <img  :src="$baseurl+parentinfo.qrCodeUrl" style="width:300px;height:300px"/>
               </div>
               <div v-if="parentinfo.qrCodeUrl" style="margin-top:5px;">
                   长按图片添加上级代理
               </div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
export default {
    data()
    {
        return{
            navitem: {
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: " sorter desc,id desc",
                    maxResultCount: 10,
                    skipCount: 0,
                    encyclopediaCateId:undefined
                },
                list: [],
            },
            loading: false,
            finished: false,
            refreshing: false,
            nshow:false,
            defaultaddress:undefined,
            curitem:undefined,
            parentinfo:undefined,
            fshow:false,
            showPicker:false,
            columns:[],
            checkvalue:''
        }
    },
    created(){
        this.querydefault();
        this.queryparentinfo();
    },
    methods:
    {
        onConfirm(value)
        {
            this.checkvalue = value;
            this.showPicker = false;
        },
        querydefault() {
            // let id=localStorage.getItem('changeaddress') || 0;
            // localStorage.setItem('changeaddress',''); 
            this.ajax
                .post("/api/services/app/PhoneUser/QueryDefaultAddress?id=0")
                .then((x) => {
                this.defaultaddress = x.result;
                });
        },
        gobuy()
        {

            this.defaultaddress.winLotteryId=this.curitem.id;
            this.defaultaddress.specId=undefined;
            if(this.curitem.isMoreSpec)
            {
                if(!this.checkvalue)
                {
                    this.$toast("请选择一个规格");
                    return;
                }
                else
                {
                    var curspec= this.curitem.easySpecInfoList.filter(x=>x.specName==this.checkvalue)[0];
                    this.defaultaddress.specId=curspec.id;
                }
            }
            this.ajax.post('/api/services/app/PhoneDrawLottery/BuyGoods',this.defaultaddress).then(x=>
            {
                this.$toast('领取成功');
                this.nshow=false;
            }).catch(x=>
            {
            })
        },
        queryparentinfo()
        {
            this.ajax.post('/api/services/app/PhoneDrawLottery/QueryMySuperiorWxQrCode').then(x=>
            {
                    this.parentinfo=x.result;
            }).catch(x=>
            {
            })
        },
        opengift(item)
        {
            this.curitem=undefined;
            this.checkvalue='';
            //this.fshow=true;

            if(item.drawLotteryEnum==2)
            {
                this.fshow=true;
            }
            if(item.drawLotteryEnum==0)
            {
                this.curitem=item;
                if(this.curitem.isMoreSpec)
                {
                    this.columns=this.curitem.easySpecInfoList.map(x=>{ return x.specName});
                }
                
                this.nshow=true;
            }

            // localStorage.setItem("drawlottery",JSON.stringify(item));
            // this.$router.push({path:'drawlotterycarddetail'});
        },
        onRefresh() {
         this.loadData("refresh");
        },
        loadData(source) {
           
        let navItem = this.navitem;
        // let state = navItem.state;

        if (source === "tabChange" && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
            //防止重复加载
            if (source != "refresh") {
            return;
            }
        }
        if (source === "refresh") {
            this.navitem.list = [];
            this.navitem.getparams.skipCount = 0;
        }
        navItem.loadingType = "loading";
        var params = navItem.getparams;
        
        //加载数据
        this.ajax
            .post("/api/services/app/PhoneDrawLottery/QueryWinLotteryList", params)
            .then((x) => {
            this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.navitem.list = this.navitem.list.concat(x.result.items);
            //console.log(this.navList);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.navitem.loadingType =
                totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
            })
            .finally(() => {
            this.$set(this.navitem, "loaded", false);
            this.refreshing = false;
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.drawcards{
    margin: 10px 20px;
    font-size: 14px;
    color:#fff;
    margin-top:-138vw;
}
.drawcard{
    padding: 10px;
    border-radius: 4px;
    background-color: #0000004d;
    margin-bottom: 10px;
}
.draw-content{
    position: relative;
    padding-left: 80px;
    min-height: 60px;
    line-height: 30px;
}
.drawcard-pic{
    position: absolute;
    left: 0;
    width: 60px;
    height: 60px;
    border-radius: 8px;
}
.drawcard-pic img{
    width: 100%;
    height: 100%;
    border-radius: 8px;
}
.drawcard-mm{
    position: absolute;
    right: 0px;
    top:0;
    font-size: 12px;
}


.oo {
    margin: 5px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 1px 1px 3px #c3c3c3;
}

.ooad {
    position: relative;
    padding: 10px 50px 10px 50px;
}

.oo-left {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);
}

.oo-right {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translate(0, -50%);
}

.tit {
    font-size: 14px;
}

.titphone {
    margin-left: 10px;
    font-size: 12px;
    color: #ababab;
}

.oold {
    padding: 10px;
}

.oonj {
    position: relative;
    min-height: 90px;
    padding-left: 90px;
}

.oonj-img {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    width: 80px;
    height: 80px;
}

.oonj-img img {
    width: 100%;
    height: auto;
    border-radius: 4px;
}

.oonj-info {}

.oonj-info-tit {
    font-size: 14px;
    margin-bottom: 5px;
    width: calc(100% - 90px);
    word-break: break-all;
}

.oonj-info-tit .price {
    position: absolute;
    right: 0;
    top: 0;
}

.oonj-info-stitc {
    color: #b1b1b1;
    margin-bottom: 5px;
    font-size: 12px;
}

.oonj-info-stitc span:last-child {
    float: right;
}

.oonj-info-stit {
    color: #b1b1b1;
    margin-bottom: 5px;
    font-size: 12px;
}

.oomain {}

.oomain-info {
    font-size: 13px;
    margin-bottom: 10px;
}

.oomain-info-dd {
    border-bottom: 1px solid #f5f5f5;
    padding: 10px 0;
    position: relative;
}

.ft {
    display: inline-block;
    width: 80px;
}

.ft-main {
    display: inline-block;
    width: calc(100% - 120px);
}

.ft-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
}

.oomain-info-dd input {
    width: calc(100% - 100px);
    border: 0;
}

.oomain-info-dd:last-child {
    border: 0;
}

.oofooter {
    text-align: right;
}

.oofooter .num {
    margin-right: 5px;
}

.oofooter .price {
    color: red;
}
</style>